import React from "react";

const disableEvent = {
  pointerEvents: "none",
  opacity: "0.6",
  cursor: "not-allowed",
};

const CardWrapper = ({ title, children, isDisabledOrder }) => {
  return (
    <div
      className="card shadow-sm border-0 rounded-4 py-4 px-3 mb-4"
      id="addOnAccordion"
      style={isDisabledOrder ? disableEvent : {}}
    >
      <h5 className="mb-0 fw-bold pb-3">{title}</h5>
      <div className="card-body px-3">{children}</div>
    </div>
  );
};

export default CardWrapper;
